import { includes } from 'ramda'
import { BOUNDS_EPWORTH_RESULTS } from '../const/epworth'
import { findKey } from './object'

// -----------------------------------------------------------------------------
// Exports
// -----------------------------------------------------------------------------

// eslint-disable-next-line import/prefer-default-export
export const getRangeEpworth = (result) =>
  findKey((key, value) => includes(result, value), BOUNDS_EPWORTH_RESULTS)
